// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__36V2D","col":"styles_col__2oP0d","fulfillmentStatus":"styles_fulfillmentStatus__qqIB5","emailCol":"styles_emailCol__2Ng3s"};